interface DistanceDisplayProps {
  distance: number | null
  unit?: 'm' | 'km'
}

export const DistanceDisplay = ({
  distance,
  unit = 'm',
}: DistanceDisplayProps) => {
  if (distance == null) return <span>-</span>

  if (unit === 'km' || distance >= 1000) {
    const km = (distance / 1000).toFixed(1)
    return <span>{km} km</span>
  }

  return <span>{Math.round(distance)} m</span>
}
